import {Tripbook} from "../../entities/Tripbook.ts";
import {TripbookRepository} from "../../../repositories/TripbookRepository.ts";

export class GetTripbooksUseCase{
    constructor(private tripbooksRepository: TripbookRepository){}
    async execute(agencyId?: string, keyword?: string): Promise<Tripbook[]>{
        return this.tripbooksRepository.getTripbooks(agencyId, keyword);
    }
}
